module.exports = __webpack_public_path__ + "static/media/Nguyen_Thuy_Dung.26018106.jpeg";